import {
  Code,
  Shield,
  Users,
  Zap,
} from 'lucide-react';

export const services = [
  {
    icon: Code,
    title: "Web Design & Development",
    description: "We build fast, modern web applications using Symfony and React. From booking systems to custom platforms, we handle the full stack so you don't have to.",
    image: "/assets/service1.png",
    features: ["Symfony & React", "Full-Stack Solutions", "Mobile-First Design", "Optimization"],
    cta: {
      label: "View case studies",
      to: "/case-studies"
    }
  },
  {
    icon: Shield,
    title: "Software Protection",
    description: "Protection for paid software that needs more than license keys. We design protected sessions, machine-aware validation, release hardening, and optional code obfuscation.",
    image: "/assets/service2.png",
    features: ["Protected Sessions", "Machine-Aware Validation", "Release Hardening", "Code Obfuscation"],
    cta: {
      label: "See protection model",
      to: "/software-protection"
    }
  },
  {
    icon: Users,
    title: "IT Outsourcing",
    description: "Need experienced developers without the hiring headaches? We provide skilled engineers who do the work.",
    image: "/assets/service4.png",
    features: ["Expert Developers", "24/7 Support", "Agile Methodology", "Cost Effective"],
    cta: {
      label: "See the model",
      to: "/for-companies"
    }
  }
];

export const testimonials = [
  {
    name: "Stanislav Krajnak",
    role: "Owner, SK Apartments",
    avatar: "https://tuke.win/sklogo.jpg",
    content: "TukeWIN transformed our entire digital infrastructure. Their web development team delivered beyond our expectations with cutting-edge solutions.",
    rating: 5,
    company: "GetRekt Ltd."
  },
  {
    name: "Denys Mazur",
    role: "Owner, IQ Apartments",
    avatar: "https://tuke.win/iqlogo.jpg",
    content: "TukeWIN developed an exceptional booking solution for our apartment rental business. The system streamlined our entire booking process and our customers love how easy it is to use. We're extremely satisfied with the results.",
    rating: 5,
    company: "IQ Apartments"
  },
  {
    name: "Maxime Cabarets",
    role: "Owner, Susano",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
    content: "The software protection services are unmatched. Our application security increased dramatically, and unauthorized access attempts dropped to zero. It gave us the confidence to ship updates faster without worrying about license abuse.",
    rating: 5,
    company: "Susano"
  },
  {
    name: "David O.",
    role: "Event Manager, NAPEN",
    avatar: "/assets/testimonials/napen.webp",
    content: "The tools built for us fit naturally into how our team already works, and the time we've saved has gone straight back into our clients. Genuinely glad we made the decision.",
    rating: 5,
    company: "NAPEN"
  },
  {
    name: "Miroslav Fabián",
    role: "Director, RazDva Accounting",
    avatar: "/assets/testimonials/razdva-logo.webp",
    content: "The cooperation has been outstanding. Our website now reflects the professionalism our clients expect, and the internal tools built for our operations have eliminated hours of manual work each week. Efficiency improved dramatically. Public or private tooling, TukeWIN has got us covered.",
    rating: 5,
    company: "RazDva Accounting"
  },
  {
    name: "Dušan Obročník",
    role: "Managing Director, GROSTAV",
    avatarInitials: "G",
    content: "We needed a website that presents GROSTAV clearly and professionally. TukeWIN understood our construction business, delivered a clean site, and made the whole process straightforward from start to finish.",
    rating: 5,
    company: "GROSTAV"
  }
];

export const stats = [
  { number: "100+", label: "Projects Delivered" },
  { number: "99.9%", label: "Uptime Guarantee" },
  { number: "24/7", label: "Direct Support" },
  { number: "0", label: "Unsatisfied Clients" }
];
